import Modal from './Modal'
import ModalFooter from './ModalFooter'

Modal.Footer = ModalFooter

export { default as FullModal } from './FullModal'
export { default as SemiModal } from './SemiModal'

export default Modal
